<template>
  <b-form-group
    label="Tedarikçi Tipi"
    label-for="id_customer_types"
  >
    <validation-provider
      #default="{ errors }"
      name="Tedarikçi Tipi"
      rules="required"
    >
      <v-select
        id="id_customer_types"
        v-model="dataItem.id_supplier_types"
        :options="supplierTypes"
        label="title"
        :reduce="supplierType => supplierType.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'SupplierType',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['suppliers/dataItem']
    },
    supplierTypes() {
      return this.$store.getters['supplierTypes/dataList']
    },
  },
  created() {
    this.getSupplierTypes()
    localize('tr')
  },
  methods: {
    getSupplierTypes() {
      this.$store.dispatch('supplierTypes/getDataList', {
        select: [
          'supplier_types.id AS id',
          'supplier_types.title AS title',
        ],
      })
    },
  },
}
</script>
